// Runtime configuration loaded from window.__CONFIG__ (injected at container startup)
// Falls back to import.meta.env for local development

declare global {
  interface Window {
    __CONFIG__?: {
      API_URL?: string;
      CLIENT_ID?: string;
      TENANT_ID?: string;
      API_SCOPE?: string;
      POWERBI_UPWARD_FEEDBACK_ENABLED?: string;
    };
  }
}

function getConfig<T extends string>(key: string, fallbackEnvKey: string, defaultValue: T): T {
  // First try runtime config (production)
  const runtimeValue = window.__CONFIG__?.[key as keyof typeof window.__CONFIG__];
  if (runtimeValue && !runtimeValue.startsWith('__')) {
    return runtimeValue as T;
  }

  // Fall back to Vite env vars (local development)
  const envValue = import.meta.env[fallbackEnvKey];
  if (envValue) {
    return envValue as T;
  }

  return defaultValue;
}

export const config = {
  apiUrl: getConfig('API_URL', 'VITE_API_URL', '/api'),
  clientId: getConfig('CLIENT_ID', 'VITE_CLIENT_ID', ''),
  tenantId: getConfig('TENANT_ID', 'VITE_TENANT_ID', ''),
  apiScope: getConfig('API_SCOPE', 'VITE_API_SCOPE', ''),
  redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
  powerBiUpwardFeedbackEnabled: getConfig<string>('POWERBI_UPWARD_FEEDBACK_ENABLED', 'VITE_POWERBI_UPWARD_FEEDBACK_ENABLED', 'true') === 'true',
};
